import * as React from 'react';
import Table from 'react-bootstrap/Table';
import { NavLink } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import Row from 'react-bootstrap/Row';
import slugify from 'slugify';
import Col from 'react-bootstrap/Col';
import { postRequest } from '../../lib/api';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import BreadcrumbsWrapper from '../../components/breadcrumbs';

export default function View() {
    const [products, setProducts] = useState([]);
      const [branchAddress, setBranchAddress] = useState('');
    const {slug} = useParams();
    const {id} = useParams();


   
    useEffect(() => {
        fetchProducts();
        fetchBranchAddress();
    }, []);

    const fetchProducts = async () => {
        try {
            // Step 1: Get all products
            const productsResponse = await postRequest('private/getproductList');
            
            if (productsResponse.status == 200) {
                // Filter out General Enquiry
                const filteredProducts = productsResponse.data.filter(
                    p => p.title !== 'General Enquiry'
                );
                
                // Step 2: Get product IDs
                const productIds = filteredProducts.map(p => p._id);
                
                // Step 3: Check manage cost status for these products for THIS specific branch
                const statusResponse = await postRequest('private/checkProductsManageStatus', {
                    productIds: productIds,
                    branchId: id  // Current branch ID from params
                });
                
                console.log('Status check response:', statusResponse);
                
                if (statusResponse.status == 200) {
                    // Create a map for easy lookup
                    const statusMap = {};
                    statusResponse.data.forEach(item => {
                        statusMap[item.productId] = item.hasManageCost;
                    });
                    
                    // Step 4: Merge products with their status
                    const productsWithStatus = filteredProducts.map(product => ({
                        ...product,
                        is_manage_cost_created: statusMap[product._id] || false
                    }));
                    
                    console.log('Final products with status:', productsWithStatus);
                    setProducts(productsWithStatus);
                }
            }
        } catch (error) {
            console.error('Failed to fetch products:', error);
        }
    };

      const fetchBranchAddress = async () => {
        try {
            const response = await postRequest(`private/getBranchDetails/${id}`);
            if (response.status === 200 && response.data?.address) {
                // You can format address as needed
                const { address1, address2, town, country, postcode } = response.data.address;
                const fullAddress = [address1, address2, town, country, postcode]
                  .filter(Boolean)
                  .join(', ');
                setBranchAddress(fullAddress);
            }
        } catch (error) {
            console.error('Failed to fetch branch address:', error);
        }
    };

    // Generate Google Maps URL from address
    const getGoogleMapsUrl = (address) => {
        if (!address) return '';
        return `https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`;
    };

    return (
        <>
         <BreadcrumbsWrapper
                     items={[
                      { label: 'Dashboard', path: '/dashboard' },
                      { label: 'Branches', path: '/branches' },
                      { label: 'view branch', path: '' },
                        ]}
                         />
                  <br></br>
            <div className='page-header pb-3'>
                <h1 className='mt-0 mb-0'>{slug}</h1>
            </div>

            <div className='page-top-formview mb-3'>
                <Row>
                    <Col sm={6}>
                        <div className='customer-tab-view'>
                            <Table responsive bordered>
                                <thead>
                                    <tr>
                                        <th colSpan={2} className='bg-grey' style={{ verticalAlign: "middle" }}>
                                            Products Offered
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {products.length > 0 ? (
                                        products.map((product, index) => {
                                            return (
                                                <tr key={product._id || index}>
                                                    <td>
                                                        {product?.is_manage_cost_created === true ? (
                                                            <CheckIcon style={{color: 'green'}} />
                                                        ) : (
                                                            <CloseIcon style={{color: 'red'}} />
                                                        )}
                                                        &nbsp; {product.title}
                                                    </td>
                                                    <td>
                                                      <Tooltip title="Manage">
    <Link
        to={`/branch/manage/${slug}/${slugify(product.title, { lower: true, strict: true })}?product_id=${product._id}&branch_id=${id}`}
        className="red-link-text"
        state={{
            product_id: product._id,
            branch_id: id
        }}
    >
        <span className="red-link-text">Manage</span>
    </Link>
</Tooltip>
                                                        &nbsp;&nbsp; | &nbsp;&nbsp;
                                                        <Tooltip title="View Lead">
                                                            <NavLink to="/#" className="red-link-text">
                                                                Search Leads
                                                            </NavLink>
                                                        </Tooltip>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={2}>No products found.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                      <Col sm={6}>
                        <iframe
                            src={getGoogleMapsUrl(branchAddress)}
                            height="450"
                            style={{ width: '100%' }}
                            title="Branch Location"
                        ></iframe>
                        <div style={{ marginTop: '8px', fontSize: '14px', color: '#555' }}>
                            {branchAddress}
                        </div>
                    </Col>
                </Row>
            </div>

        </>
    );
}
